import React from "react";
import './styles.css';
import { countObjectsWithValue } from "../../lib/countObjects";
import rootDir from "../..";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import Sorter from './Sorter'

interface Props {
    data: any;
    myRegion: string;
    searchRegion: string;
}

const SongListTable = ({data, myRegion, searchRegion}: Props) => {
    return (
        <div className="songlist">
            <table id="songlist-table" cellPadding={3} cellSpacing={3} >
                <thead>
                    <tr>
                        { !isMobile ? <th><Sorter sorter='id'/></th> : null}
                        <th title='Artist Name'>Artist <Sorter sorter='artist'/></th>
                        <th title='Song Title'>Title <Sorter sorter='song'/></th>
                        <th title='Album Title'>Album <Sorter sorter='album'/></th>
                        <th title='Song Length' className="songlength">Length <Sorter sorter='duration'/></th>
                        <th title='Genres'>Genre</th>
                        {/* <th title='Total Plays'>Plays <Sorter sorter='plays'/></th> */}
                        <th title='Arrangements'>Arr</th>
                        <th title='RS Official DLCs'>DLC</th>
                        <th title='Regions'>Reg</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        Object.keys(data).map((i, j) => (
                            <tr className={data[j].is_available ? "" : "delistedSong" }>
                                { !isMobile ? <td title={ data[j].song_id }>{ data[j].is_available ? <img src={rootDir+'img/verified.png'} height={20} alt='Available' title='Song is Available in R+, check regions'/> : <img src={rootDir+'img/delisted.png'} alt='Delisted' height={20} title='Song is Delisted' /> }</td> : null}
                                <td>{data[j].inhouse_cover ? <span className="inhouseCover" title="Made Famous By">(MFB) </span> : null}<Link to={ rootDir+'artist/'+data[j].artist_id}>{data[j].artist}</Link></td>
                                <td className={data[j].inhouse_cover ? "inhouseCover" : "song"} title={
                                    data[j].inhouse_cover ? 
                                    'This song is flagged as an inhouse cover, it is not the original recording' : 
                                    data[j].title}
                                >
                                    {/* {data[j].video.web ? <img src={ rootDir+"img/YT.png"} height={16} alt="YouTube video" /> : null} */}
                                    <Link to={ rootDir+'song/'+data[j].song_id}>{data[j].title} {data[j].has_lyrics ? <img src={rootDir+"img/lyrics.png"} alt="Has Lyrics" title="Has Lyrics" height={16}/> : null} {data[j].explicit ? <img src={rootDir+"img/explicit.png"} alt="Explicit Lyrics" title="Explicit Lyrics" height={16}/> : null}</Link></td>
                                <td>{data[j].album_cover ? <img src={data[j].album_cover} height={20} alt="Album Cover" /> : null
                                    } <Link to={ rootDir+'album/'+data[j].album_id}>{data[j].album}</Link></td>
                                <td className="songlength">{ data[j].time}</td>
                                <td className="genre">{ Object.keys(data[j].genre).map((k,l) => (<button title={data[j].genre[l]}>{data[j].genre[l]}</button>)) }</td>
                                {/* <td className="plays">{ data[j].plays }</td> */}
                                <td className="arr-cell">{ Object.keys(data[j].arrangements).map((k,l) => (<img src={rootDir+'img/arr/'+k+'.png'} alt={k} title={'Has '+k} height={16} />))}</td>
                                <td className="dlc-cell">{ data[j].is_official_rs1 === true ? <img src={rootDir+'img/RS1.png'} alt='Official RS1 DLC' height={16} title='Official RS1 DLC' /> : null} {data[j].is_official_rs2014 === true ? <img src={rootDir+'img/RS2014.png'} alt='Official RS2014 DLC' height={16} title='Official RS2014 DLC' /> : null} {data[j].was_in_beta === true ? <img src={rootDir+'img/RS+.png'} alt='Was in RS+ Beta' height={16} title='Was in RS+ Beta' /> : null}</td>
                                <td className="region-cell">{ data[j].region[myRegion] ? <img src={rootDir+'img/flag/'+myRegion+'.png'} alt={myRegion} height={16} title={"Available in "+myRegion}/> : null} {data[j].region[searchRegion] ? <img src={rootDir+'img/flag/'+searchRegion+'.png'} alt={searchRegion} height={16} title={"Available in "+searchRegion}/> : null} <span className="reg-y"><select className="reg-y"><option selected>Yes:&nbsp;{countObjectsWithValue(data[j].region, true)}</option>{Object.entries(data[j].region).map(([i,v],j) => (v === true ? <option>{i}</option> : null))}</select></span> <span className="reg-n">No:&nbsp;{countObjectsWithValue(data[j].region, false)}</span></td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>

    );
}

export default SongListTable